var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.46 7.418H18.543A11.16 11.16 0 0 0 7.418 18.543v32.856L21.806 37.01a11.403 11.403 0 0 1 15.724 0l10.646 10.705 3.293-3.293a11.16 11.16 0 0 1 15.731 0l14.385 14.392V18.544A11.16 11.16 0 0 0 70.46 7.418",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.53 37.01a11.403 11.403 0 0 0-15.724 0L7.418 51.4v19.06a11.16 11.16 0 0 0 11.125 11.126H70.46a11.12 11.12 0 0 0 8.01-3.412z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.584 58.806 67.2 44.422a11.16 11.16 0 0 0-15.73 0l-3.293 3.293 30.278 30.441a11 11 0 0 0 3.13-7.698z",
    opacity: 0.25
  }))));
};
export default SvgImage;